import React, { useEffect, useState } from 'react';
import axios from "axios";
import { API_BASE_URL } from "../../config";
import {useParams} from "react-router-dom";
import {toast, ToastContainer} from "react-toastify";
import Button from "../Elements/Button";

const SectionTechniqueDetailsDnsZone = () => {
    let {id} = useParams(); // Get the 'id' parameter from the URL
    id = parseInt(id);
    const [tempDNSZone, setTempDNSZone] = useState('');

    useEffect(() => {
        axios.post(`${API_BASE_URL}/get_customer_dns_zone/`, { id })
            .then(res => {
                const zone = res.data.result[0].zone || ''; // Ensure fallback to empty string
                setTempDNSZone(zone);
            })
            .catch(err => console.error('Error fetching DNS zone:', err));
    }, [id]);

    const saveDNSZone = () => {
        axios.post(`${API_BASE_URL}/set_customer_dns_zone/`, { zone: tempDNSZone, customer_id: id })
            .then(res => {
                console.log(res.data);

                toast.success("Zone DNS modifiée.");
            })
            .catch(err => {

                toast.error("Une erreur est survenue lors de l'enregistrement de la zone DNS.");
                console.error('Error saving DNS zone:', err)
            });
    };

    return (
        <div>
            <ToastContainer position="bottom-right" autoClose={3000}/>
            <div className={"display-flex flex-direction-column gap-20 mb-20"}>
                <label>
                    <h3 className={"color-third"}>Zone DNS</h3>
                </label>
                <div class="h-separator"></div>
                <textarea
                    style={{fontFamily: "Consolas"}}
                    className="position-note-textarea min-h-400"
                    value={tempDNSZone}
                    onChange={(e) => setTempDNSZone(e.target.value)}
                />
                <Button onClick={saveDNSZone} icon={"fa-floppy-disk"}
                        label={"Enregistrer"}
                        textClassNames={"bg-third text-white btn-save"}
                        iconBackground={'bg-fifth'} disableLink/>
            </div>

        </div>
    );
};

export default SectionTechniqueDetailsDnsZone;
